<ng-template [ngIf]="formType == '1'">
    <form [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="!hideForm">
        <app-content-control *ngIf="controls" [contentControls]="controls"></app-content-control>
        <div class="m-t-15">
    
            <ion-text *ngIf="errorMessage" color="danger" class="m-l-5">
                <span class="f-12">Something went wrong</span>
            </ion-text>
    
            <ng-template [ngIf]="submitButton">
                <div [ngStyle]="wrapperStyle">
                <ion-button #submitButtonRef type="submit" 
                    [attr.disabled]="(form.invalid || inProgress)"
                    mode="ios" fill="outline" [size]="submitButton.size">
                    <span *ngIf="!inProgress">{{ submitButton.text }}</span>
                    <span *ngIf="inProgress">Submitting...</span>
                    </ion-button>
                </div>
            </ng-template>
        </div>
       
    </form>
    <div *ngIf="hideForm && afterSubmit.mode === 1" class="m-t-10 m-b-10">
        <div *ngIf="afterSubmit.message" [froalaView]="afterSubmit.message">
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="formType == '2'">
    <app-form-patch [config]="config" [data]="data"></app-form-patch>
</ng-template>

<ng-template [ngIf]="formType == '3'">
    <app-form-patch [config]="config" [data]="data"></app-form-patch>
</ng-template>



